module.exports = "/_next/static/files/a4dd17958660395c06a3cdb299ff02ae.jpg";